import { useCallback } from 'react';
import { ConfirmationDialog } from '@kinesis/bungle';
import { noop } from 'lodash/fp';

const RevokeConfirmation = (props: RevokeConfirmationProps) => {
  const {
    clientName,
    onRevoke = noop,
    onClose = noop,
    animation = true,
  } = props;
  const onConfirm = useCallback(() => {
    onRevoke();
    onClose();
  }, [onRevoke, onClose]);
  return (
    <ConfirmationDialog
      animation={animation}
      confirmText='Revoke access'
      cancelText='Keep access'
      icon='exclamation'
      title={`Revoke ${clientName}?`}
      onCancel={onClose}
      onConfirm={onConfirm}
      showCancelButton
      variant='danger'
      minWidth={320}
    >
      {clientName} will immediately lose access to your Kinesis account. Any
      tokens it holds will stop working. It can request access again later.
    </ConfirmationDialog>
  );
};

export type RevokeConfirmationProps = {
  clientName: string;
  onRevoke?: () => void;
  onClose?: () => void;
  animation?: boolean;
};

export { RevokeConfirmation };
